import { handleActions } from 'redux-actions';
import { api } from 'api/api';

import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";

const LOADER = 'FCM_LOADER';
const HIDE_ALERT = 'HIDE_ALERT';
const MESSAGING = 'MESASSING';
export const constants = {
  LOADER,
  MESSAGING
};
// ------------------------------------
// Actions
// ------------------------------------

export const setHideAlert = (value) => (dispatch) => {
  dispatch({ type: HIDE_ALERT, hideAlert: value });
};

export const initializeFirebase = () => async (dispatch) => {
  try {
    const data = await api.get('fcm/firebase');

    // Inicializa Firebase modular
    const firebaseApp = initializeApp(data);
    const messaging = getMessaging(firebaseApp);

    dispatch({ type: MESSAGING, messaging });
    dispatch({ type: 'SET_FIREBASE_APP', firebaseApp });
  } catch (e) {
    console.error('Error al iniciar firebase.', e);
  }
};

export const newToken = (token) => (dispatch) => {
  const body = {token};
  api.post('fcm/nuevo', body).catch((error) => {}).then((data) => {
    dispatch({ type: HIDE_ALERT, hideAlert: true });
  });
};

export const actions = {
  setHideAlert,
  initializeFirebase,
  newToken,
};

export const reducers = {
  [HIDE_ALERT]: (state, { hideAlert }) => {
    return {
      ...state,
      hideAlert,
    };
  },
  [MESSAGING]: (state, { messaging }) => {
    return {
      ...state,
      messaging,
    };
  },
  [MESSAGING]: (state, { messaging }) => ({ ...state, messaging }),
  ['SET_FIREBASE_APP']: (state, { firebaseApp }) => ({ ...state, firebaseApp })
};

export const initialState = {
  hideAlert: false,
  messaging: {},
  firebaseApp: null,
};

export default handleActions(reducers, initialState);
